<template>
  <sl-page>
    <div class='page-filter'>
      <Row :gutter="12">
        <Col span="8" :lg="8" :md="8" :sm="12" :xs="24" class="margin-bottom">
        <Input v-model="params.applierName" placeholder="申请人姓名"></Input>
        </Col>
        <Col span="8" :lg="8" :md="8" :sm="12" :xs="24" class="margin-bottom">
        <Input v-model="params.applierPhone" placeholder="申请人联系电话"></Input>
        </Col>
        <Col span="8" :lg="8" :md="8" :sm="24" :xs="24" class="page-action">
        <div>
          <Button type="primary" icon="ios-search" @click="list()">搜索</Button>
          <Button icon="ios-reset" @click="reset()">清空</Button>
        </div>
        <div>
          <Button v-permission="'car.section.insert'" type="primary" icon="md-add" @click="create()">新增</Button>
        </div>
        </Col>
      </Row>
    </div>
    <div class="pg-bd">
      <sl-table ref="table" :loading="loading" :page="page" :columns="columns" :data="data" @on-selection-change="handleSelect" @on-update="handleChange"></sl-table>
    </div>
    <car-no-section-item ref="item" @on-update="handleUpdate" />
  </sl-page>
</template>
<script>
import carNoSectionItem from './detail'
import { carNoRange } from '../partial/utils'
const columns_ = [{
    type: 'index',
    width: 65,
    title: '序号',
    align: 'center'
  },
  {
    title: '号段区间',
    minWidth: 150,
    key: 'carNoRange'
  },
  {
    title: '获取数量',
    minWidth: 90,
    key: 'applyCount'
  },
  {
    title: '设备厂商',
    minWidth: 100,
    key: 'brand'
  },
  {
    title: '获取时间',
    key: 'applyDatetimeText',
    minWidth: 160,
  },
  {
    title: '申请理由',
    key: 'reason',
    minWidth: 120,
  },
  {
    title: '申请人姓名',
    key: 'applierName',
    minWidth: 120,
  },
  {
    title: '申请人电话',
    key: 'applierPhone',
    minWidth: 120,
  }
]


export default {
  components: { carNoSectionItem },
  data() {
    return {
      columns: [
        ...columns_,
/*        {
          title: '操作',
          key: 'action',
          width: 200,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('a', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.edit(params)
                  }
                }
              }, '编辑'),
              h('a', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.remove(params)
                  }
                }
              }, '删除')
            ])
          }
        }*/
      ],
      data: [],
      params: {
        applierName: null,
        applierPhone: null,
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      selection: []
    }
  },
  computed: {
    removeDisable() {
      return this.selection.length == 0
    }
  },
  created() {
    this.def = { ...this.params }
    this.list()
  },

  methods: {

    list() {
      let params = { search: { ...this.params }, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.$request.carNoSections(params).then(resp => {
        console.log(resp)
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data.list || [], { 
            'type': '$carType' , 
            'applyDatetime':'datetime',
            carNoRange
          })
          this.page.total = resp.data.total || 0
        }
      })
    },

    edit({ row }) {
      this.$refs['item'].init(row.id)
    },

    create() {
      this.$refs['item'].init(0)
    },


    reset() {
      this.$utils.fill(this.params, this.def)
      this.list()
    },

    handleUpdate() {
      this.modalVisible = false
      this.list()
    },

    handleChange(pageNum, pageSize) {
      if (this.page.pageNum != pageNum || this.page.pageSize != pageSize) {
        this.page.pageNum = pageNum
        this.page.pageSize = pageSize
        this.list()
      }
    },

    handleSelect(selection) {
      this.selection = selection.map(i => i.id)
    }
  }
}

</script>
